const ForgotPasswordClient = {
  forgotUrl: "password-management/forget",
  resetPasswordUrl: (secretCode?: string): string => {
    let url = "/password-management/reset";
    const params = new URLSearchParams();

    if (secretCode) {
      params.append("secret", secretCode);
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    return url;
  },
};

export default ForgotPasswordClient;
